export default function useSegmentedTest<T extends keyof SegmentedTests>(name: T): SegmentedTests[T] {
	const fallback = () => {
		try {
			const stored = window.sessionStorage.getItem(name);

			return stored ? (JSON.parse(stored) as SegmentedTests[T]) : undefined;
		} catch {
			return undefined;
		}
	};

	return window.segmentedTests?.[name] ?? fallback();
}

window.SegmentedTest = <T extends keyof SegmentedTests>(name?: T) => ({
	get: name ? useSegmentedTest(name) : window.segmentedTests,
	set(value: SegmentedTests[T]) {
		if (!name) return;

		window.segmentedTests ??= {};

		window.sessionStorage.setItem(name, JSON.stringify(value));
		window.segmentedTests[name] = value;
	},
});
